//3rd Party Components
import React from 'react';
import PropTypes from 'prop-types';

const Menu = ({ signoutLink }) => {

        return (
            <div className="casa-sign-out">

                <div className="au-body au-body--dark">
                    <a className="au-btn au-btn--dark" href={signoutLink} >Sign out</a>
                </div>

            </div>
        );
}

Menu.propTypes = {
    signoutLink: PropTypes.string.isRequired
};

export default Menu;
